export default __webpack_public_path__ + "static/media/screenshot.073a9e8c.svg";